(function () {
  function perView(slideshow) {
    if (!slideshow) return 1;
    var m = parseInt(slideshow.getAttribute('data-carousel-mobile-columns') || '1', 10);
    var d = parseInt(slideshow.getAttribute('data-carousel-columns') || '1', 10);
    if (window.matchMedia('(max-width: 749px)').matches) return m;
    if (window.matchMedia('(max-width: 989px)').matches) return Math.min(d, 3);
    return d;
  }
  function sync(fill, scroller, slideshow) {
    var slides = scroller.closest('[data-testid="carousel-section"]').querySelectorAll('[data-carousel-card]').length;
    if (!slides) return;
    var view = perView(slideshow);
    var needsScroll = slides > view;
    var indicator = fill.closest('.carousel-content__indicator');
    if (indicator) indicator.hidden = !needsScroll;
    var max = scroller.scrollWidth - scroller.clientWidth;
    var pages = Math.ceil(slides / view);
    var fillPct = 100 / pages;
    var r = max > 0 ? scroller.scrollLeft / max : 0;
    fill.style.width = fillPct + '%';
    fill.style.left = (r * (100 - fillPct)) + '%';
  }
  function init(root) {
    var scroller = root.querySelector('[ref="scroller"]');
    var fill = root.querySelector('.carousel-content__progress-fill');
    var slideshow = root.querySelector('slideshow-component');
    var endTimer;
    if (!scroller || !fill || scroller.dataset.carouselProgress) return;
    scroller.dataset.carouselProgress = '';
    var update = function () { sync(fill, scroller, slideshow); };
    scroller.addEventListener('scroll', function () {
      fill.style.transition = 'none';
      update();
      clearTimeout(endTimer);
      endTimer = setTimeout(function () { fill.style.transition = ''; }, 120);
    }, { passive: true });
    new ResizeObserver(update).observe(scroller);
    update();
  }
  function initAll() {
    document.querySelectorAll('[data-testid="carousel-section"]').forEach(init);
  }
  initAll();
  document.addEventListener('cart:update', function () { requestAnimationFrame(initAll); });
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(initAll, 0); }).observe(document.documentElement, { childList: true, subtree: true });
})();
